<template>
	<div class="walter-asyncmap-root">
		<div
			v-if="loading"
			class="walter-asyncmap__status"
		>
			{{ $t('walteriaLoadingMap') }}
		</div>
		<div
			v-else-if="error"
			class="walter-asyncmap__status walter-asyncmap__status--error"
		>
			{{ $t('walteriaMapError') }}
		</div>
		<template v-else-if="geojson">
			<!-- Placeholder inline; clicar abre o visualizador de mapa único. -->
			<MapView :geojson="geojson" />
			<div class="walter-asyncmap__actions">
				<button
					type="button"
					class="walter-asyncmap__btn walter-asyncmap__btn--download"
					@click="downloadGeoJson"
				>
					📥 GeoJSON
				</button>
			</div>
		</template>
	</div>
</template>

<script>
import walterIAApi from '../../../services/clients/WalterIAClient'
import MapView from './MapView.vue'

export default {
	name: 'AsyncMap',
	components: { MapView },
	props: {
		url: { type: String, required: true },
	},
	data() {
		return { geojson: null, loading: true, error: false }
	},
	watch: {
		// componente reusado ao trocar de conversa: refaz a busca ao mudar a url
		url() {
			this.fetchGeoJson()
		},
	},
	mounted() {
		this.fetchGeoJson()
	},
	methods: {
		async fetchGeoJson() {
			this.loading = true
			this.error = false
			this.geojson = null
			try {
				const res = await walterIAApi.get(this.url)
				this.geojson = res.data
			} catch {
				this.error = true
			} finally {
				this.loading = false
			}
		},
		downloadGeoJson() {
			if (!this.geojson) return
			const blob = new Blob([JSON.stringify(this.geojson, null, 2)], { type: 'application/json' })
			const url = URL.createObjectURL(blob)
			const a = document.createElement('a')
			a.href = url
			a.download = 'mapa.geojson'
			a.click()
			URL.revokeObjectURL(url)
		},
	},
}
</script>

<style scoped>
.walter-asyncmap-root {
	margin: 8px 0;
	min-width: 450px;
}
.walter-asyncmap__status {
	text-align: center;
	padding: 16px;
	color: #737576;
	font-size: 13px;
}
.walter-asyncmap__status--error {
	color: #c60020;
}
.walter-asyncmap__actions {
	display: flex;
	gap: 8px;
	margin-top: 8px;
}
.walter-asyncmap__btn {
	display: inline-flex;
	align-items: center;
	gap: 4px;
	font-size: 12px;
	padding: 4px 10px;
	border-radius: 4px;
	cursor: pointer;
}
.walter-asyncmap__btn--download {
	border: 1px solid #d1e7dd;
	background: #ecfdf5;
	color: #166534;
}
</style>
